import React, { FC } from 'react';
import { Box, Button, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { RiHome3Line, RiContactsBookLine, RiUser3Line, RiLineChartLine, RiSettings4Line, RiProfileLine } from 'react-icons/ri';
import style from './main-layout.module.scss';
import AddIcon from '@material-ui/icons/Add';
import { LcardBadge } from 'components/shared/lcard-badge/index';
import { NavLink } from 'react-router-dom';
import { AppRoute } from 'enums/appRoute';
import { UserMenu } from 'components/shared/user-menu';

const menuItems = [
 { name: 'Home', icon: <RiHome3Line />, path: AppRoute.HOME },
 { name: 'Cards', icon: <RiContactsBookLine />, path: AppRoute.MYCARDS },
 { name: 'URL Designer', icon: <RiProfileLine />, path: AppRoute.URLDESIGNER },
 { name: 'My Profile', icon: <RiUser3Line />, path: AppRoute.MYPROFILE },
 { name: 'Analytics', icon: <RiLineChartLine />, path: AppRoute.ANALYTICS },
 { name: 'Settings', icon: <RiSettings4Line />, path: AppRoute.SETTINGS },
];

export const MainLayout: FC = ({ children }) => {
 return (
  <div className={style.container}>
   <div>
    <Box className={style.sideMenu}>
     <div className={style.sideMenuLogo}>
      <LcardBadge color='#fff' />
     </div>
     <List className={style.menuList}>
      {menuItems.map((menu) => (
       <NavLink key={menu.path} to={menu.path} exact activeClassName={style.activeMenu}>
        <ListItem button>
         <ListItemIcon>{menu.icon}</ListItemIcon>
         <ListItemText primary={menu.name} />
        </ListItem>
       </NavLink>
      ))}
     </List>
    </Box>
   </div>
   <div className={style.content}>
    <div className={style.appBar}>
     <UserMenu />
     <Button variant='contained' color='primary'>
      <AddIcon />
      Create Card
     </Button>
    </div>
    <div className={style.contentChildren}>{children}</div>
   </div>
  </div>
 );
};
